var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamilyGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.002,
    height: 30,
    viewBox: "0 0 30.002 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M-421.263,415.262c-2.49,0-4.98.006-7.47,0a4.5,4.5,0,0,1-2.719-.839,3.785,3.785,0,0,1-1.58-3,16.175,16.175,0,0,1,.812-6.138,6.352,6.352,0,0,1,1.91-2.928,4.579,4.579,0,0,1,2.927-1.009,1.343,1.343,0,0,1,.643.237c.468.28.907.61,1.377.887a7.587,7.587,0,0,0,8.1.058,6.4,6.4,0,0,0,1.048-.693,2.232,2.232,0,0,1,2.144-.367,4.936,4.936,0,0,1,3.359,2.886,11.058,11.058,0,0,1,1.031,3.665,27.445,27.445,0,0,1,.182,3.093,3.953,3.953,0,0,1-3.708,4.1,7.872,7.872,0,0,1-.846.049Q-417.66,415.266-421.263,415.262Z",
    transform: "translate(436.27 -385.264)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M-335.348,212.846a6.414,6.414,0,0,1-6.446-6.419,6.424,6.424,0,0,1,6.423-6.444,6.421,6.421,0,0,1,6.447,6.42A6.416,6.416,0,0,1-335.348,212.846Z",
    transform: "translate(350.358 -195.704)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M-461.216,131.221a4.257,4.257,0,0,1-4.258,4.285,4.266,4.266,0,0,1-4.321-4.255,4.285,4.285,0,0,1,4.218-4.306A4.267,4.267,0,0,1-461.216,131.221Z",
    transform: "translate(470.859 -126.945)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M-136.292,135.5a4.257,4.257,0,0,1-4.284-4.289,4.268,4.268,0,0,1,4.307-4.272A4.28,4.28,0,0,1-132,131.224,4.268,4.268,0,0,1-136.292,135.5Z",
    transform: "translate(160.93 -126.943)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M-125.665,274.716c.606.1,1.186.215,1.773.281a6.511,6.511,0,0,0,3.441-.738c.363-.164.711-.362,1.067-.542a1.031,1.031,0,0,1,1.229.307.453.453,0,0,1,.055.245c0,2.372,0,4.744.007,7.115a.316.316,0,0,1-.191.316,4.253,4.253,0,0,1-2.084.478c-.644.01-1.288.007-1.933,0a.456.456,0,0,1-.3-.118,5.87,5.87,0,0,0-4.336-2.031A7.453,7.453,0,0,0-125.665,274.716Z",
    transform: "translate(148.096 -265.032)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M-479.1,280a5.855,5.855,0,0,0-3.622,1.343,3.4,3.4,0,0,0-.526.506.806.806,0,0,1-.759.314c-.76-.032-1.522-.019-2.282-.05a3.127,3.127,0,0,1-1.491-.46.37.37,0,0,1-.159-.264q-.013-3.587,0-7.174a.469.469,0,0,1,.135-.3.987.987,0,0,1,1.248-.169,10.24,10.24,0,0,0,3.008,1.164,6.284,6.284,0,0,0,2.889-.2l.288-.082A7.462,7.462,0,0,0-479.1,280Z",
    transform: "translate(487.95 -265.003)",
    fill: "#7a7a7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyGroupIcon);
export default __webpack_public_path__ + "static/media/FamilyGroupIcon.4f9533a0f78822e7dca3a6f87cc2ba5f.svg";
export { ForwardRef as ReactComponent };